export default function ({ ...props }) {
    return (
        <svg width="73" height="72" viewBox="0 0 73 72" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_10551_3399)">
                <path
                    d="M14.9344 18.4H56.9344C58.4016 18.4 59.5344 19.5567 59.5344 20.9143V51.0858C59.5344 52.4434 58.4016 53.6001 56.9344 53.6001H14.9344C13.4672 53.6001 12.3344 52.4434 12.3344 51.0858V20.9143C12.3344 19.5567 13.4672 18.4 14.9344 18.4Z"
                    stroke="#03060B"
                    strokeWidth="3.2"
                    strokeLinejoin="round"
                />
                <line x1="13.9336" y1="36.8" x2="57.9336" y2="36.8" stroke="#2164FF" strokeWidth="3.2" />
                <path
                    d="M38.3348 36.8C41.2066 36.8 43.5348 34.4719 43.5348 31.6C43.5348 28.7281 41.2066 26.4 38.3348 26.4C35.4629 26.4 33.1348 28.7281 33.1348 31.6C33.1348 34.4719 35.4629 36.8 38.3348 36.8Z"
                    stroke="#2164FF"
                    strokeWidth="3.2"
                />
                <path
                    d="M47.1332 36.8C49.1214 36.8 50.7332 35.0092 50.7332 32.8C50.7332 30.5909 49.1214 28.8 47.1332 28.8C45.145 28.8 43.5332 30.5909 43.5332 32.8C43.5332 35.0092 45.145 36.8 47.1332 36.8Z"
                    stroke="#2164FF"
                    strokeWidth="3.2"
                />
                <path d="M35.5332 40.8L42.7332 35.2L49.9332 40.8" stroke="#2164FF" strokeWidth="3.2" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_10551_3399">
                    <rect width="50.4" height="50.4" fill="white" transform="translate(10.7344 10.4)" />
                </clipPath>
            </defs>
        </svg>
    );
}
